


















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import { Center } from '@core/interfaces/tenant-state';

@Component({
  name: 'bpc-header-user-area',
  components: {
    VuePerfectScrollbar,
  },
})
export default class HeaderTenantsSelector extends Vue {
  @Prop({ type: String, default: '' }) readonly tenantName: string;
  public search: string = '';

  get tenants() {
    return this.$store.getters['tenant/tenants'];
  }

  get filteredTenants() {
    return this.tenants.filter(tenant => {
      return tenant.name.toLowerCase().includes(this.search.toLowerCase());
    });
  }

  get withSearch() {
    return this.tenants.length > 5;
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get hasCustomDomain(): boolean {
    return this.$clientRouter.hasCustomDomain();
  }

  changeTenant(tenant: Center): void {
    this.$authService.navigateToTenantWithAuthByQuery(tenant.alias);
  }
}
